import React from "react";
import { URLImgFront } from '../../../config/URLDB';
import { RedencionCampania_, Agencias_ } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { getCustomSelectStyles } from '../../../utils/selectStyles';
import { validarOTPGenerico } from '../../../utils/ValidacionOtp';
import Loading from '../../Loading';
import ReactDOM from 'react-dom';

class CarritoRedencion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            aceptapoli: false,
            aceptacontacto: false,
            agencias: [],
            agenciaSeleccionada: '',
            agenciaError: false,
            estadoLoading:false
        };
    }

    componentDidMount() {
        this.Agencias();
    }

    handleCheckChange = (e) => {
        this.setState({ [e.target.id]: e.target.checked });
    };

    convertirCarritoXml = () => {
        const { carrito } = this.props;
        const items = carrito.map(item => `
             <item>
                 <idredencion>${item.idredencion}</idredencion>
                 <cantidadreclamado>${item.cantidad}</cantidadreclamado>
                 <valor>${item.valor}</valor>
             </item>
         `).join("");

        const xml = `<carrito>${items}</carrito>`;
        return xml;
    }

    Agencias = () => {
        const data = {
            tran: 12,
            idredagencia: 0,
            idtipoagencia: 0,
            idmunicipio: 0,
            nombreagenc: 'NA',
            descagencia: 'NA',
            rutaiconomapa: 'NA',
            latitud: 'NA',
            longitud: 'NA',
            zoom: 0,
            estado: 0,
            usucrea: 'NA'
        }

        Agencias_(data).then(response => {
            if (response.data.length > 0) {
                const agenciasOptions =
                    response.data
                        .map(item => ({
                            value: item.agencia,
                            label: item.agencia,
                        }));
                this.setState({ agencias: agenciasOptions });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'No se encontró información de agencias!'
                })
            }
        }).catch(err => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Fallo el cargue de agencias' });
        });;
    }

    RedimirCarrito = async (data) => {
        if (this.state.agenciaSeleccionada === "") {
            this.setState({ agenciaError: true });
            return;
        }
        if (this.props.nit === "" || this.props.nombre === "" || this.props.celular === "") {
            Swal.fire({ icon: 'warning', title: 'Advertencia', text: `Debes consultar tus puntos antes de redimir.` });
            return;
        }

        this.setState({
            estadoLoading: true
        });

        const xmlCarrito = this.convertirCarritoXml();
        const body = {
            tran: 1,
            idconfigcampania: 32,
            id_cliente: this.props.idcliente,
            numcontacto: this.props.celular,
            correo: this.props.correo,
            agencia: this.state.agenciaSeleccionada.value,
            aceptapoli: this.state.aceptapoli ? 1 : 0,
            aceptacontacto: this.state.aceptacontacto ? 1 : 0,
            xml: xmlCarrito,
        }

        const otpValidado = await validarOTPGenerico({
            idTipoDoc: 1,
            tipoIden: this.props.tipoiden,
            nit: this.props.nit,
            numeroCelular: this.props.celular,
            tipPer: 1,
            correo: this.props.correo,
            nomCom: this.props.nombre,
            codMotOtp: 12,
            idProceso: 1,
            idMedioNotificacion: 1,
        });

        if (!otpValidado) {
            this.setState({ estadoLoading: false });
            this.props.cerrarOverlay();
            return;
        }

        RedencionCampania_(body).then(result => {
            if (result.data[0] && result.data[0].codresp) {
                try {
                    const codresp = result.data[0]?.codresp?.split(";")[2]?.trim();
                    const idredencion = result.data[0]?.codresp?.split(";")[1]?.trim();
                    const itemEncontrado = this.props.carrito.find(item => item.idredencion == idredencion);
                    switch (codresp) {
                        case "0":
                            Swal.fire({ icon: 'success', title: 'Exitoso', text: result.data[0]?.codresp?.split(";")[1]?.trim() });
                            this.props.cerrarOverlay()
                            break
                        case "1":
                            this.props.onCambiarCantidad(itemEncontrado.idredencion, 0)
                            Swal.fire({ icon: 'warning', title: 'Advertencia', text: `El siguiente artículo ${itemEncontrado.descredencion} no se encuentra disponible` });
                            break
                        case "2":
                            this.props.onCambiarCantidad(itemEncontrado.idredencion, 0)
                            Swal.fire({ icon: 'warning', title: 'Advertencia', text: `El siguiente artículo ${itemEncontrado.descredencion} ya fue redimido anteriormente, por lo que no es posible su redención. Continua con la redención de los demás artículos` });
                            break
                        case "3":
                            Swal.fire({ icon: 'warning', title: 'Advertencia', text: `Los puntos disponibles no aplican para realizar la redención` });
                            break
                        case "4":
                            Swal.fire({ icon: 'warning', title: 'Advertencia', text: result.data[0]?.codresp?.split(";")[1]?.trim() });
                            break
                        default:
                            Swal.fire({ icon: 'error', title: 'Error', text: `Estamos presentando novedad con el proceso de redencion.` });
                            break
                    }
                    if (!this.props.carrito || this.props.carrito.length === 0) {
                        this.props.cerrarOverlay()
                    }
                } catch (error) {
                    Swal.fire({ icon: 'error', title: 'Error', text: `Estamos presentando novedad con el proceso de redencion.` });
                }
            }
        }).catch(err => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo completar el proceso de redencion.' });
        });

        this.setState({
            estadoLoading: false
        });
    }

    CensurarEmail(email) {
        const str = String(email ?? "");
        const atIndex = str.indexOf("@");
        if (atIndex <= 3) return str;
        return "*".repeat(atIndex - 3) + str.slice(atIndex - 3);
    }

    CensurarFormatted(valor, caracteres = 4) {
        const str = String(valor ?? "");
        if (str.length <= caracteres) return str;
        return "*".repeat(str.length - caracteres) + str.slice(-caracteres);
    }

    render() {
        const { carrito, onVolver, onCambiarCantidad, total } = this.props;
        const { aceptapoli, aceptacontacto } = this.state;
        const habilitarRedimir = aceptapoli && aceptacontacto;
        const totalProductos = carrito.length;

        return (
            <div className="container-fluid py-4" data-aos="fade-up" data-aos-delay="3240">
                <div className="row justify-content-center">
                    <div className="col-12 col-xl-11">
                        <div className="rounded-lg shadow overflow-hidden" style={{ background: "#F4F6F8" }}>
                            <div className="row no-gutters">
                                <div className="col-12 col-lg-8 p-4">
                                    <h2 style={{ color: "#2F647C", fontWeight: 700 }}>
                                        Carrito de redención{" "}
                                        <span className="font-weight-normal">{totalProductos} productos - Total: {total}</span>
                                    </h2>
                                    <div className="d-none d-md-flex border-bottom pb-2 mt-4 font-weight-bold" style={{ color: "#2F647C", fontSize: "0.85rem" }}>
                                        <div className="col-5 pl-0">Detalle de producto</div>
                                        <div className="col-3 text-center">Cantidad</div>
                                        <div className="col-2 text-center">Puntos</div>
                                        <div className="col-2 text-center">Total puntos</div>
                                    </div>

                                    {carrito.map((item) => (
                                        <div key={item.idredencion} className="row align-items-center mt-3 pb-3 border-bottom">
                                            <div className="col-12 col-md-5 d-flex align-items-center mb-2 mb-md-0">
                                                <img src={`${URLImgFront}/assets/EstrategiasComerciales${item.img}`} alt={item.descredencion} className="rounded mr-3" style={{ width: 50, height: 50, objectFit: "cover", flexShrink: 0 }} />
                                                <div>
                                                    <p className="mb-0 font-weight-bold" style={{ color: "#FF6201", fontSize: "0.9rem" }}>
                                                        {item.descredencion}
                                                    </p>
                                                    <small className="text-muted">
                                                        {item.categoria === "1" ? "Elementos hogar" : "Elementos personal"}
                                                    </small>
                                                    <br />
                                                    <button className="btn btn-link btn-sm p-0 m-0" style={{ fontSize: "0.75rem", color: "#FF6201", fontWeight: 600 }} onClick={() => onCambiarCantidad(item.idredencion, 0)}>
                                                        Eliminar
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-6 col-md-3">
                                                <small className="d-block d-md-none text-muted mb-1">Cantidad</small>
                                                <div className="d-flex align-items-center justify-content-start justify-content-md-center">
                                                    <div className="text-center font-weight-bold mx-1" style={{ minWidth: 32, padding: "4px 6px", color: "#FF6201", fontSize: "0.9rem", }}>
                                                        {item.cantidad}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-3 col-md-2 text-md-center">
                                                <small className="d-block d-md-none text-muted mb-1">Puntos</small>
                                                <span style={{ color: "#FF6201", fontWeight: 600 }}>{item.valor}</span>
                                            </div>

                                            <div className="col-3 col-md-2 text-md-center">
                                                <small className="d-block d-md-none text-muted mb-1">Total</small>
                                                <span style={{ color: "#FF6201", fontWeight: 700 }}> {item.valor * item.cantidad} </span>
                                            </div>
                                        </div>
                                    ))}
                                    <button className="pt-2 mt-4 border-0 bg-transparent" >
                                        <img src={`${URLImgFront}/assets/EstrategiasComerciales/Regresar.svg`} alt="Regresar" onClick={onVolver} style={{ width: 'auto', height: '30px', touchAction: 'manipulation' }} />
                                    </button>
                                </div>
                                <div className="col-12 col-lg-4 p-4" style={{ background: "#E9ECEF" }}>
                                    <h3 className="mb-4" style={{ color: "#2F647C" }}>Información</h3>
                                    <div>
                                        <input id="nomcom" placeholder={"Nombre completo"} className="form-control mb-3 border-0" value={this.props.nombre} disabled={true} style={{ borderRadius: 13, background: "#FFF", padding: "10px 16px" }} />
                                        <input id="nit" placeholder={"Número de identificación"} className="form-control mb-3 border-0" value={this.props.nit} disabled={true} style={{ borderRadius: 13, background: "#FFF", padding: "10px 16px" }} />
                                        <input id="telcel" placeholder={"Número de contacto"} className="form-control mb-3 border-0" value={this.CensurarFormatted(this.props.celular)} disabled={true} style={{ borderRadius: 13, background: "#FFF", padding: "10px 16px" }} />
                                        <input id="correo" placeholder={"Correo electrónico"} className="form-control mb-3 border-0" value={this.CensurarEmail(this.props.correo)} disabled={true} style={{ borderRadius: 13, background: "#FFF", padding: "10px 16px" }} />
                                        <Select name="agencia" options={this.state.agencias} className="mb-3" value={this.state.agenciaSeleccionada} onChange={(selected) => this.setState({ agenciaSeleccionada: selected, agenciaError: false })} placeholder="Agencia mas cercana…" isClearable menuPortalTarget={document.body} menuPosition="fixed"
                                            closeMenuOnScroll={(e) => e.target === document || e.target === document.body || e.target.tagName === 'HTML'}
                                            styles={{
                                                ...getCustomSelectStyles(),
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            }}
                                        />
                                        {this.state.agenciaError && (<small style={{ color: "#F22800" }}>Por favor seleccione una agencia.</small>)}
                                    </div>
                                    <div style={{ fontSize: "0.8rem", color: "#666" }}>
                                        <div className="form-check mb-2">
                                            <input className="form-check-input" type="checkbox" checked={this.state.aceptapoli} onChange={this.handleCheckChange} id="aceptapoli" />
                                            <label className="form-check-label pt-2 pl-2" htmlFor="aceptapoli">
                                                Acepto términos y condiciones
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" checked={this.state.aceptacontacto} onChange={this.handleCheckChange} id="aceptacontacto" />
                                            <label className="form-check-label pt-2 pl-2" htmlFor="aceptacontacto">
                                                Acepto ser contactado por correo o teléfono
                                            </label>
                                        </div>
                                    </div>
                                    <button className="pt-2 border-0 bg-transparent w-100" disabled={!habilitarRedimir} onClick={this.RedimirCarrito}>
                                        <img src={`${URLImgFront}/assets/EstrategiasComerciales/Redimir.svg`} alt="Redimir" style={{ width: '100%', height: '50px', touchAction: 'manipulation' }} />
                                    </button>
                                </div>
                                {this.state.estadoLoading && (
                                    ReactDOM.createPortal(
                                        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1059, backgroundColor: 'rgba(0,0,0,0.4)', overflowY: 'auto', paddingTop: '120px' }} className="d-flex align-items-start align-items-md-center justify-content-center" >
                                            <div style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', overflow: 'hidden', zIndex: 1059 }}>
                                                <Loading alto={'100%'} />
                                            </div>
                                        </div>,
                                        document.body)
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CarritoRedencion;